import { get } from "./base";

export function createMaintenanceReport(deviceID) {
  return get(`reports/maintenance/${deviceID}`);
}
